<div class="row mb-2">
  <div class="col-12">
    <div class="row mb-3">
      <div class="col-12 col-md-5 d-none">
        <label class="mb-2">Tags</label><br />
        <!--<select id="contentTags" multiple size="1" class="form-select form-select-sm"
          data-placeholder="All Tags"
          [(ngModel)]="helpFilters.tags">
    <option value="">- All -</option>
    <option *ngFor="let tag of listContentTags; trackBy: trackByFn" [value]="tag.id">#{{ tag.tag }}</option>
  </select>-->
        <ng-multiselect-dropdown [placeholder]="'Choose Content Tags'"
                                 [settings]="dropdownSettings"
                                 [data]="listContentTags"
                                 [(ngModel)]="helpFilters.tags"
                                 (onSelect)="onItemSelect($event)"
                                 (onSelectAll)="onSelectAll($event)">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-12 col-md-3 d-none">
        <label class="mb-2">Status</label>
        <select class="form-select form-select-sm" [(ngModel)]="helpFilters.active">
          <option value="-1">- All -</option>
          <option value="1">Active</option>
          <option value="0">Inactive</option>
        </select>
      </div>
      <div class="col-12 col-md-3">
        <div *ngIf="authAdmin">
          <label class="mb-2">Actions</label><br />
          <button class="btn btn-sm btn-dark" (click)="addContent()">
            <i class="fas fa-fw fa-plus-square me-2"></i>Add New
          </button>
        </div>
      </div>
    </div>
    
    <div class="row mb-2">
      <div class="col-12">
        <div class="row">
          <div class="col-12 col-md-3" *ngFor="let file of listContent">
            <div style="position: relative; padding-bottom: 56.25%; height: 0;">
              <iframe [src]="file.content_url" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
            </div>
            <div class="my-2">
              <div class="video_title my-2">{{file.title}}</div>
              <div class="video_decription my-2">{{file.description}}</div>
              <div class="video_timestamp c_orange">
                <div class="my-1 c_green" *ngIf="file.tags !== null">{{file.tags}}</div>
                {{file.dt_created}}
                <span class="ms-auto pointer" (click)="editHelpAsset(file.id)"  *ngIf="authAdmin">
                  <i class="fas fa-fw fa-cog m-2"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="backdrop" [ngStyle]="{'display':showModal}"></div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':showModal}" id="contentModal">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="container-fluid p-0">
          <div class="row m-0 p-0">
            <div class="col-12 col-md-6 p-0 modal-title"></div>
            <div class="col-12 col-md-6 p-0 text-end">
              <button type="button" class="btn btn-sm btn-light my-1" alt="Close" title="Close" (click)="toggleModal('hide')">
                <i class="fas fa-fw fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <span></span>
      </div>
      <div class="modal-body">
        <div class="card">
          <div class="card-body">
            <div class="mb-2">
              <label class="mb-2">URL</label>
              <input id="helpURL" type="text" [disabled]="helpAsset.mode == 'edit'" [(ngModel)]="helpAsset.url" class="form-control form-control-sm" />
            </div>
            <div class="mb-2">
              <label class="mb-2">Title</label>
              <input id="helpTitle" type="text" [(ngModel)]="helpAsset.title" class="form-control form-control-sm" />
            </div>
            <div class="mb-2">
              <label class="mb-2">Description</label>
              <textarea id="helpDescription" [(ngModel)]="helpAsset.description" rows="3" class="form-control form-control-sm"></textarea>
            </div>
            <div class="mb-2 d-none">
              <label class="mb-2">Tags</label>
              <select multiple size="{{listContentTags.length}}" id="helpTags" [(ngModel)]="helpAsset.tags" class="form-select form-select-sm">
                <option *ngFor="let tag of listContentTags; trackBy: trackByFn" [value]="tag.id">#{{ tag.tag }} - {{ tag.tag_description }}</option>
              </select>
            </div>
            <div class="mb-2">
              <label class="mb-2">Active</label>
              <select id="helpActive" [(ngModel)]="helpAsset.active" class="form-select form-select-sm">
                <option value="1">Yes</option>
                <option value="0">No</option>
              </select>
            </div>
            <!-- <div class="mb-2 text-center">
              <div class="alert alert-sm alert-danger p-2" *ngIf="errorMsg != ''">{{errorMsg}}</div>
              <button class="btn btn-sm btn-dark me-2" (click)="saveHelpAsset()">
                <i class="fas fa-fw fa-save me-2"></i>Save
              </button>
              <button class="btn btn-sm btn-light" (click)="clearHelpAsset()" [disabled]="helpAsset.mode == 'edit'">
                <i class="fas fa-fw fa-arrow-rotate-right me-2"></i>Clear
              </button>
            </div> -->
          </div>
        </div>
      </div>
      <div class="modal-footer text-center d-none">
        <button type="button" class="btn btn-dark my-1" title="Save">
          <i class="fas fa-fw fa-save"></i>
        </button>
        <button type="button" class="btn btn-light my-1" alt="Close" title="Close">
          <i class="fas fa-fw fa-times"></i>
        </button>
      </div>
    </div>
  </div>
</div>
